export enum FeedDocumentType {
  FEEDBACK = 'feedback',
  EXPERTISE = 'expertise',
  OTHER = 'other',
}
